<template>
    <div class="modal-content tw-text-left tw-px-6 tw-relative">
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6 tw-sticky tw-top-0 tw-left-0 tw-w-full tw-pt-6 tw-bg-white">
            <h4 class="tw-font-bold tw-text-lg">{{ $t('privacyPolicy.title') }}</h4>
            <div class="modal-close tw-cursor-pointer tw-z-50" @click="$store.dispatch('closeAllModals')">
                <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567"><g transform="translate(16.821 16.749) rotate(180)"><path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5"/></g></svg>
            </div>
        </div>
        <div class="tw-max-h-3/4 tw-h-64 tw-overflow-y-auto">
            <h1>Política de proteção de dados e respetivo consentimento</h1>
            <p>A Euroteste Marketing e Opinião S.A., com sede na Praça José Queirós, Nº 1 piso 3 fração 1 a 3, Lisboa, Portugal, com o número único de matrícula na Conservatória do Registo Comercial de Lisboa e de pessoa coletiva 502113332 (doravante designada por KANTARWORLDPANEL), procede à recolha e tratamento de dados pessoais dos seus Colaboradores (doravante designados por Painelistas)..</p>
            <p>São esses dados transmitidos pelo colaborador:</p>
            <p>Aquando da aceitação da colaboração; No envio e recepção de produtos e ou equipamentos; Através da nossa página de internet e ou aplicação smartphone.</p>
            <p></p><br>
            <p>Os dados pessoais recolhidos são:</p>
            <p>1. Nome;</p>
            <p>2. Morada;</p>
            <p>3. Números de telefone fixo e móvel;</p>
            <p>4. Endereço de correio eletrónico (e-mail);</p>
            <p>5. Dados demográficos relativos à composição do agregado familiar</p>
            <p>6. Dados demográficos sobre posse de equipamentos no lar em que o painelista seja proprietário.</p>
            <p></p><br>
            <p>O tratamento dos dados pessoais dos painelistas da KANTARWORLDPANEL é da responsabilidade desta e consiste em:</p>
            <p>1. Realização de inquéritos de análise ao consumo;</p>
            <p>2. Realização de inquéritos de estudos de mercado e de opinião.</p>
            <p></p><br>
            <p>De acordo com o Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho, de 27 de abril de 2016, todos os painelistas da KANTARWORLDPANEL têm o direito de:</p>
            <p>1. Em qualquer momento, retirar o consentimento para o tratamento dos dados pessoais;</p>
            <p>2. Proceder ou solicitar a correção de qualquer dado pessoal que o Titular dos dados pessoais tenha fornecido;</p>
            <p>3. Aceder aos mesmos a qualquer momento;</p>
            <p>4. Opor-se a que os mesmos sejam utilizados para efeitos de marketing e/ou publicitários;</p>
            <p>5. Solicitar a portabilidade dos mesmos, para a entidade que, para esse efeito indicar;</p>
            <p>6. Solicitar o apagamento de todos os dados pessoais que tenha fornecido pelo presente meio, e que não sejam necessários para o cumprimento de quaisquer obrigações legais pela entidade responsável pela recolha dos mesmos, nomeadamente, para efeitos de campanhas de segurança e/ou de garantia legal ou contratual;</p>
            <p>7. Ser informado pela KANTARWORLPANEL se esta, eventualmente, tiver intenção de proceder ao tratamento dos dados pessoais para outros fins que não os que, pelo presente é dado consentimento.</p>
            <p></p><br>
            <p>A KANTARWORLPANEL, sendo responsável pelo tratamento dos dados dos seus Clientes, transmite-os a:</p>
            <p>1. Entidades contratadas pela KANTARWORLPANEL cujo objetivo seja para envio e recepção dos leitores de códigos de barras.     </p>
            <p>2. Entidades contratadas pela KANTARWORLPANEL seja para envio e recepção  de brindes por mim solicitados pela troca de pontos acumulados durante a colaboração.</p>
            <p></p><br>
            <p>Para quaisquer informações, assim como para o exercício dos direitos que lhe são legalmente conferidos, o painelista deve contactar a KANTARWORLPANEL solicitando por escrito para a morada abaixo indicada ou por email para contactowp@kantarworlpanel.com</p>
            <br><br>
            <p>Morada para anulação do consentimento: </p>
            <p>Departamento de Qualidade</p>
            <p>Praça José Queirós, nº1 </p>
            <p>Piso 3, Fracção 1 e 3</p>
            <p>1800-237 Lisboa Portugal</p>
            <p></p><br>
            <p>Os dados serão conservados por um período de 10 anos, a não ser que o titular dos dados retire o seu consentimento à utilização destes.</p>
            <p>O Titular dos dados pessoais é também plena e claramente informado que poderá apresentar qualquer reclamação, quanto à violação dos seus direitos, junto da Comissão Nacional de Proteção de Dados.</p>
            <p></p><br>

            <h4><b>{{ $t('privacyPolicy.dataProcessor.title') }}</b></h4>
            <p>{{ $t('privacyPolicy.dataProcessor.text', { company:company }) }}</p>
        </div>
        <div class="terms-footer tw-sticky tw-bg-white tw-bottom-0 tw-py-6">
            <button type="button" class="btn-cta" @click.prevent="$store.state.privacyPolicy = true; $store.state.modal.terms = false;">
                {{ $t('privacyPolicy.accept') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    data() {
        return {
            company: process.env.VUE_APP_COMPANY,
        };
    },
};
</script>

<style lang="scss" scoped>
.terms-footer {
    .btn-cta {
        max-width: 100%;
    }
}

</style>
